import { Controller } from "@hotwired/stimulus"

// Renders a .docx into the page with docx-preview. The library (and jszip) only
// load when a learner actually opens a Word document.
export default class extends Controller {
  static targets = ["container", "fallback"]
  static values = { url: String }

  connect() {
    this.renderToken = 0
    this.render()
  }

  disconnect() {
    this.renderToken += 1
  }

  async render() {
    const token = ++this.renderToken
    const container = this.hasContainerTarget ? this.containerTarget : null
    if (!container || !this.urlValue) {
      this.showFallback()
      return
    }

    try {
      const response = await fetch(this.urlValue, { credentials: "same-origin" })
      if (!response.ok) throw new Error(`Failed to fetch file (${response.status})`)
      const blob = await response.blob()
      if (token !== this.renderToken) return

      const { renderAsync } = await import("docx-preview")
      if (token !== this.renderToken) return

      container.innerHTML = ""
      await renderAsync(blob, container)
    } catch (error) {
      console.error("Failed to render docx preview:", error)
      if (token !== this.renderToken) return
      this.showFallback()
    }
  }

  showFallback() {
    if (this.hasContainerTarget) this.containerTarget.hidden = true
    if (this.hasFallbackTarget) this.fallbackTarget.hidden = false
  }
}
